/*
 * File created for running jasmine tests in node.
 * Webpack config makes require call to _gaq return window._gaq.
 * However webpack is not used when running tests from node. Hence,
 * check if _gaq exists on window (as webpack does) and return it if it exists
 * else it returns empty object
 */

module.exports = window._gaq || {};



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/helpers/gaq.js
// module id = 2631
// module chunks = 63